module.exports = __webpack_public_path__ + "static/background_mobile-ca55da31526091b6384ed3faa1a12d47.png";